import React from "react";
import { Route, Switch } from "react-router-dom";
// import loading from "./utils/loading"
import Index from "./pages/Index";
import './App.scss';

class App extends React.Component {

  componentDidMount() {
    /* 写在App组件中保证loading逻辑一定会被执行 */
    // loading.hide()
    // setTimeout(() => { loading.hide }, 500);
    // this.props.history.listen((route) => {
    //   window.scrollTo(0, 0);
    // });
  }


  render() {
    return (
      <div>
        <Switch>
          <Route exact path="/" component={Index} />
        </Switch>
      </div>
    )
  }
}

export default App